//Name: Male Shoe Sizes
//Code: SHOW
//Age: Adult
//Gender: Male
const maleShoeSizes = [
  { id: '174', values: [
    {region: "AU", name: "1"},
    {region: "NZ", name: "1"},
    {region: "US", name: "1.5"},
    {region: "UK", name: "1"},
    {region: "EU", name: "33"}
  ]},
  { id: '175', values: [
    {region: "AU", name: "1.5"},
    {region: "NZ", name: "1.5"},
    {region: "US", name: "2"},
    {region: "UK", name: "1.5"},
    {region: "EU", name: "33.5" }
  ]},
  { id: '176', values: [
    {region: "AU", name: "2"},
    {region: "NZ", name: "2"},
    {region: "US", name: "2.5"},
    {region: "UK", name: "2"},
    {region: "EU", name: "34"}
  ]},
  { id: '66', values: [
    {region: "AU", name: "2.5"},
    {region: "NZ", name: "2.5"},
    {region: "US", name: "3"},
    {region: "UK", name: "2.5"},
    {region: "EU", name: "34.5"}
  ]},
  { id: '67', values: [
    {region: "AU", name: "3"},
    {region: "NZ", name: "3"},
    {region: "US", name: "3.5"},
    {region: "UK", name: "3"},
    {region: "EU", name: "35"}
  ]},
  { id: '68', values: [
    {region: "AU", name: "3.5"},
    {region: "NZ", name: "3.5"},
    {region: "US", name: "4"},
    {region: "UK", name: "3.5"},
    {region: "EU", name: "35.5"}
  ]},
  { id: '69', values: [
    {region: "AU", name: "4"},
    {region: "NZ", name: "4"},
    {region: "US", name: "4.5"},
    {region: "UK", name: "4"},
    {region: "EU", name: "36"}
  ]},
  { id: '70', values: [
    {region: "AU", name: "4.5"},
    {region: "NZ", name: "4.5"},
    {region: "US", name: "5"},
    {region: "UK", name: "4.5"},
    {region: "EU", name: "37"}
  ]},
  { id: '71', values: [
    {region: "AU", name: "5"},
    {region: "NZ", name: "5"},
    {region: "US", name: "5.5"},
    {region: "UK", name: "5"},
    {region: "EU", name: "38"}
  ]},
  { id: '72', values: [
    {region: "AU", name: "5.5"},
    {region: "NZ", name: "5.5"},
    {region: "US", name: "6"},
    {region: "UK", name: "5.5"},
    {region: "EU", name: "38.5"}
  ]},
  { id: '73', values: [
    {region: "AU", name: "6"},
    {region: "NZ", name: "6"},
    {region: "US", name: "6.5"},
    {region: "UK", name: "6"},
    {region: "EU", name: "39"}
  ]},
  { id: '74', values: [
    {region: "AU", name: "6.5"},
    {region: "NZ", name: "6.5"},
    {region: "US", name: "7"},
    {region: "UK", name: "6.5"},
    {region: "EU", name: "40"}
  ]},
  { id: '75', values: [
    {region: "AU", name: "7"},
    {region: "NZ", name: "7"},
    {region: "US", name: "7.5"},
    {region: "UK", name: "7"},
    {region: "EU", name: "41"}
  ]},
  { id: '76', values: [
    {region: "AU", name: "7.5"},
    {region: "NZ", name: "7.5"},
    {region: "US", name: "8"},
    {region: "UK", name: "7.5"},
    {region: "EU", name: "42"}
  ]},
  { id: '77', values: [
    {region: "AU", name: "8"},
    {region: "NZ", name: "8"},
    {region: "US", name: "8.5"},
    {region: "UK", name: "8"},
    {region: "EU", name: "43"}
  ]},
  { id: '78', values: [
    {region: "AU", name: "8.5"},
    {region: "NZ", name: "8.5"},
    {region: "US", name: "9"},
    {region: "UK", name: "8.5"},
    {region: "EU", name: "43.5"}
  ]},
  { id: '79', values: [
    {region: "AU", name: "9"},
    {region: "NZ", name: "9"},
    {region: "US", name: "9.5"},
    {region: "UK", name: "9"},
    {region: "EU", name: "44"}
  ]},
  { id: '80', values: [
    {region: "AU", name: "9.5"},
    {region: "NZ", name: "9.5"},
    {region: "US", name: "10"},
    {region: "UK", name: "9.5"},
    {region: "EU", name: "44.5"}
  ]},
  { id: '81', values: [
    {region: "AU", name: "10"},
    {region: "NZ", name: "10"},
    {region: "US", name: "10.5"},
    {region: "UK", name: "10"},
    {region: "EU", name: "45"}
  ]},
  { id: '82', values: [
    {region: "AU", name: "10.5"},
    {region: "NZ", name: "10.5"},
    {region: "US", name: "11"},
    {region: "UK", name: "10.5"},
    {region: "EU", name: "45.5"}
  ]},
  { id: '83', values: [
    {region: "AU", name: "11"},
    {region: "NZ", name: "11"},
    {region: "US", name: "11.5"},
    {region: "UK", name: "11"},
    {region: "EU", name: "46"}
  ]},
  { id: '84', values: [
    {region: "AU", name: "11.5"},
    {region: "NZ", name: "11.5"},
    {region: "US", name: "12"},
    {region: "UK", name: "11.5"},
    {region: "EU", name: "46.5"}
  ]},
  { id: '85', values: [
    {region: "AU", name: "12"},
    {region: "NZ", name: "12"},
    {region: "US", name: "12.5"},
    {region: "UK", name: "12"},
    {region: "EU", name: "47"}
  ]},
  { id: '86', values: [
    {region: "AU", name: "12.5"},
    {region: "NZ", name: "12.5"},
    {region: "US", name: "13"},
    {region: "UK", name: "12.5"},
    {region: "EU", name: "47.5"}
  ]},
  { id: '87', values: [
    {region: "AU", name: "13"},
    {region: "NZ", name: "13"},
    {region: "US", name: "13.5"},
    {region: "UK", name: "13"},
    {region: "EU", name: "48"}
  ]},
  { id: '177', values: [
    {region: "AU", name: "13.5"},
    {region: "NZ", name: "13.5"},
    {region: "US", name: "14"},
    {region: "UK", name: "13.5"},
    {region: "EU", name: "48.5"}
  ]},
  { id: '178', values: [
    {region: "AU", name: "14"},
    {region: "NZ", name: "14"},
    {region: "US", name: "14.5"},
    {region: "UK", name: "14"},
    {region: "EU", name: "49"}
  ]}
];
export default maleShoeSizes;



// WEBPACK FOOTER //
// ./src/data/male-shoe-sizes.js